import { StateProperty } from '@app/common';
import { setTransientStateProperties } from '../../../store/moduleStateSlice';
import { store } from '../../../store/store';

export function getUrlWithTransientStateProperties(pathname: string): string {
    const properties = store.getState().moduleState.transientStateProperties.sort();
    return `${pathname}?${properties.join('&')}`;
}

export function getPathNameAndRestoreTransientStateProperties(url: string): string {
    const match = url.match(/([^?]+)[?](.*)$/);
    if (match !== null) {
        const properties = match[2].split('&') as StateProperty[];
        store.dispatch(setTransientStateProperties(properties));
        return match[1];
    } else {
        throw new Error('Could not parse pathname and restore the transient state properties from url');
    }
}

export function getFavoriteId(pathname: string): `fav_${string}` {
    return `fav_${getUrlWithTransientStateProperties(pathname)}`;
}